import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { TableComponents, TableVirtuoso } from "react-virtuoso";
import React from "react";
import { boxStyle } from "../../../../consts/styles";

interface Data {
  id: number;
  description: number;
  total: number;
  zone: number;
}
interface ColumnData {
  dataKey: keyof Data;
  label: string;
  numeric?: boolean;
  width: number;
}

var columns: ColumnData[] = [
  {
    width: 100,
    label: "จังหวัด",
    dataKey: "description",
  },
  {
    width: 100,
    label: "จำนวนที่เพิ่ม (คน)",
    dataKey: "total",
  },
];

const VirtuosoTableComponents: TableComponents<any> = {
  Scroller: React.forwardRef<HTMLDivElement>((props, ref) => (
    <TableContainer
      sx={{ boxShadow: "none", borderRadius: 0 }}
      {...props}
      ref={ref}
    />
  )),
  Table: (props) => (
    <Table
      {...props}
      sx={{ borderCollapse: "separate", tableLayout: "fixed" }}
    />
  ),
  TableHead,
  TableRow: ({ item: _item, ...props }) => <TableRow {...props} />,
  TableBody: React.forwardRef<HTMLTableSectionElement>((props, ref) => (
    <TableBody {...props} ref={ref} />
  )),
};

const fixedHeaderContent = () => {
  return (
    <TableRow>
      {columns.map((column: any) => (
        <TableCell
          key={column.dataKey}
          variant="head"
          align="center"
          style={{ width: column.width }}
          sx={{
            padding: "10px 0",
            backgroundColor: "#2CADF2",
          }}
        >
          <Typography variant="body1" sx={{ fontWeight: 600 }} color="white">
            {column.label}
          </Typography>
        </TableCell>
      ))}
    </TableRow>
  );
};

const rowContent = (_index: number, row: any) => {
  return (
    <React.Fragment>
      {columns.map((column) => (
        <TableCell
          key={column.dataKey}
          align="center"
          sx={{
            borderBottom: "none",
            background: _index % 2 !== 0 ? "#F5F7FA" : "",
          }}
        >
          {column.dataKey === "id" && (
            <Typography variant="subtitle2" color="black.main">
              เขตสุขภาพที่ {row[column.dataKey]?.toLocaleString()}
            </Typography>
          )}

          {column.dataKey !== "id" && (
            <Typography variant="subtitle2" color="black.main">
              {row[column.dataKey]?.toLocaleString()}
            </Typography>
          )}
        </TableCell>
      ))}
    </React.Fragment>
  );
};

const MemberTypeTable = ({ members }: any) => {
  return (
    <Box sx={boxStyle}>
      <Typography
        align="center"
        typography={{ xs: "h4", sm: "h3" }}
        color="black.main"
      >
        จังหวัดที่มีผู้ลงทะเบียนเพิ่มขึ้น
      </Typography>

      <Box
        sx={{
          height: 400,
          background: "#FFFFFF",
          borderRadius: "10px",
        }}
      >
        <TableVirtuoso
          data={members}
          components={VirtuosoTableComponents}
          fixedHeaderContent={fixedHeaderContent}
          itemContent={rowContent}
        />
      </Box>
    </Box>
  );
};

export default MemberTypeTable;
